"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinks = exports.CUSTOMER_TYPES = void 0;

var _react = _interopRequireDefault(require("react"));

var _NomadInsuranceSvg = _interopRequireDefault(require("../assets/products/NomadInsuranceSvg"));

var _RemoteHealthCompaniesSvg = _interopRequireDefault(require("../assets/products/RemoteHealthCompaniesSvg"));

var _RemoteDoctorSvg = _interopRequireDefault(require("../assets/products/RemoteDoctorSvg"));

var _BuildingremotelySvg = _interopRequireDefault(require("../assets/products/BuildingremotelySvg"));

var _BorderlessSvg = _interopRequireDefault(require("../assets/products/BorderlessSvg"));

var _CoworkingCollectionSvg = _interopRequireDefault(require("../assets/products/CoworkingCollectionSvg"));

var _theme = require("../style/theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CUSTOMER_TYPES = {
  INDIVIDUAL: "Nomads",
  COMPANY: "Remote startups"
};
exports.CUSTOMER_TYPES = CUSTOMER_TYPES;

var getLinks = function getLinks(mainSiteUrl, enableRemoteDoctor) {
  var PRODUCT_NI = {
    label: "Nomad Insurance",
    url: "".concat(mainSiteUrl, "/nomad-insurance"),
    sub: "Global health and travel insurance for nomads and remote workers",
    img: /*#__PURE__*/_react.default.createElement(_NomadInsuranceSvg.default, {
      width: "38px",
      height: "100%"
    }),
    color: (0, _theme.th)("colors.turquoise"),
    customer: CUSTOMER_TYPES.INDIVIDUAL,
    id: "nomad-insurance"
  };
  var PRODUCT_RH_COMPANY = {
    label: "Remote Health",
    url: "".concat(mainSiteUrl, "/remote-health"),
    sub: "Global health insurance for your remote team",
    img: /*#__PURE__*/_react.default.createElement(_RemoteHealthCompaniesSvg.default, {
      width: "55px",
      height: "100%"
    }),
    color: "#9a9ae7",
    customer: CUSTOMER_TYPES.COMPANY,
    id: "remote-health"
  };
  var PRODUCT_RD = {
    label: "Remote Doctor",
    url: "".concat(mainSiteUrl, "/remote-doctor"),
    sub: "Virtual healthcare from anywhere in the world",
    img: /*#__PURE__*/_react.default.createElement(_RemoteDoctorSvg.default, {
      width: "46px",
      height: "100%",
      style: {
        marginLeft: "8px"
      }
    }),
    color: (0, _theme.th)("colors.jordyBlue"),
    customer: CUSTOMER_TYPES.INDIVIDUAL,
    id: "remote-doctor"
  };
  return {
    products: enableRemoteDoctor ? [PRODUCT_NI, PRODUCT_RH_COMPANY, PRODUCT_RD] : [PRODUCT_NI, PRODUCT_RH_COMPANY],
    tools: [{
      label: "Borderless",
      url: "https://borderless.safetywing.com",
      openInNewTab: true,
      sub: "City guides for nomads and borderless living",
      img: /*#__PURE__*/_react.default.createElement(_BorderlessSvg.default, {
        width: "50px",
        height: "100%"
      }),
      alignIconToTop: true,
      color: (0, _theme.th)("colors.turquoise")
    }, {
      label: "Building Remotely",
      url: "https://buildingremotely.com",
      sub: "A comprehensive guide to building and scaling a remote company",
      img: /*#__PURE__*/_react.default.createElement(_BuildingremotelySvg.default, {
        width: "37px",
        height: "100%"
      }),
      alignIconToTop: true,
      color: "#9B9BE8"
    }, {
      label: "The Coworking Collection",
      url: "".concat(mainSiteUrl, "/perks"),
      sub: "Coworking and coliving spaces with discounts for SafetyWing members",
      img: /*#__PURE__*/_react.default.createElement(_CoworkingCollectionSvg.default, {
        width: "44px",
        height: "100%"
      }),
      alignIconToTop: true,
      color: (0, _theme.th)("colors.orchid")
    }],
    about: [{
      label: "Blog",
      url: "".concat(mainSiteUrl, "/blog")
    }, {
      label: "Team",
      url: "".concat(mainSiteUrl, "/team")
    }, {
      label: "Partners",
      url: "".concat(mainSiteUrl, "/partners")
    }, {
      label: "Contact us",
      url: "".concat(mainSiteUrl, "/contact")
    }, {
      label: "Join us",
      url: "".concat(mainSiteUrl, "/join-us")
    }]
  };
};

exports.getLinks = getLinks;